import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/contents/tms-2/typical-tms-treatment")({
  beforeLoad: () => {
    throw redirect({ to: "/contents/tms/typical-tms-treatment" });
  },
});
